import React from 'react';
import { Link } from 'react-router-dom';
import milltechLogo from '../../assets/miltech logo.png';
import footerBg     from '../../assets/footer.jpg';
import locationIcon from '../../assets/location.png';
import './Footer.css';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="footer" style={{ '--footer-bg': `url(${footerBg})` }}>
      <div className="footer__overlay" />

      <div className="footer__top">
        <div className="container footer__grid">

          {/* ── Brand ── */}
          <div className="footer__brand">
            <Link to="/" className="footer__logo">
              <div className="footer__logo-img-wrap">
                <img src={milltechLogo} alt="MILLTECH CNC" className="footer__logo-img" />
              </div>
              <div>
                <span className="footer__logo-brand"><em>Milltech</em></span>
                <span className="footer__logo-sub"> CNC</span>
              </div>
            </Link>
            <p className="footer__tagline">
              Manufacturer of Heavy Engineering Components,<br/>
              Heavy Machining and Fabrication since 2002.
            </p>
            <div className="footer__iso">
              <span className="footer__iso-badge">ISO 9001:2015</span>
              <span className="footer__iso-label">Certified — Unit I</span>
            </div>
            <div className="footer__dir">
              <span className="footer__dir-label">Partners</span>
              <span className="footer__dir-name">V. Natarajan · Baraneetharan · C.A Baskar</span>
            </div>
          </div>

          {/* ── Services ── */}
          <div className="footer__col">
            <h4 className="footer__col-title">Services</h4>
            <ul className="footer__links">
              <li><Link to="/services/aerospace" className="footer__link">Aerospace Machining</Link></li>
              <li><Link to="/services/windmill"  className="footer__link">Windmill Components</Link></li>
              <li><Link to="/services/cement"    className="footer__link">Cement Machinery</Link></li>
              <li><Link to="/machines"           className="footer__link">CNC Machines</Link></li>
              <li><Link to="/products"           className="footer__link">Products</Link></li>
            </ul>

            <h4 className="footer__col-title" style={{marginTop:'1.75rem'}}>Major Clients</h4>
            <ul className="footer__links">
              {['ISRO (VSSC · LPSC)', 'BrahMos Aerospace', 'L&T Defence', 'IGCAR', 'FLSmidth'].map(c => (
                <li key={c}><span className="footer__link footer__link--muted">{c}</span></li>
              ))}
            </ul>
          </div>

          {/* ── Contact ── */}
          <div className="footer__col">
            <h4 className="footer__col-title">Contact Us</h4>
            <ul className="footer__contact-list">

              <li className="footer__contact-item">
                <span className="footer__contact-icon">📞</span>
                <div>
                  <a href="tel:+919444955108" className="footer__link">+91 94449 55108</a><br/>
                  <a href="tel:+918072518489" className="footer__link">+91 80725 18489</a><br/>
                  <a href="tel:+919444058659" className="footer__link">+91 94440 58659</a><br/>
                  <a href="tel:+918072515869" className="footer__link">+91 80725 15869</a>
                </div>
              </li>

              <li className="footer__contact-item">
                <span className="footer__contact-icon">✉️</span>
                <div>
                  <a href="mailto:sales.milltechcnc@gmail.com" className="footer__link">sales.milltechcnc@gmail.com</a><br/>
                  <a href="mailto:info.milltechcnc@gmail.com"  className="footer__link" style={{fontSize:'0.77rem'}}>info.milltechcnc@gmail.com</a><br/>
                  <a href="mailto:natarajan.vm1971@gmail.com"  className="footer__link" style={{fontSize:'0.77rem'}}>natarajan.vm1971@gmail.com</a><br/>
                  <a href="mailto:btharan76@gmail.com"         className="footer__link" style={{fontSize:'0.77rem'}}>btharan76@gmail.com</a><br/>
                  <a href="mailto:baranee_i@rediffmail.com"    className="footer__link" style={{fontSize:'0.77rem'}}>baranee_i@rediffmail.com</a>
                </div>
              </li>

              <li className="footer__contact-item">
                <span className="footer__contact-icon footer__contact-icon--loc">
                  <img src={locationIcon} alt="Location" className="footer__loc-icon-img" />
                </span>
                <div>
                  <p className="footer__address-label">Unit I</p>
                  <a
                    href="https://www.google.com/maps/place/MILLTECH+CNC/@12.9770853,80.083075,17z/data=!3m1!4b1!4m6!3m5!1s0x3a5267473fc40905:0x11649cef00b96a27!8m2!3d12.9770853!4d80.083075!16s%2Fg%2F11fmy0mnr1?entry=ttu&g_ep=EgoyMDI2MDYyMS4wIKXMDSoASAFQAw%3D%3D"
                    target="_blank" rel="noopener noreferrer"
                    className="footer__address"
                  >
                    101/1, 14th Main Road, SIDCO Industrial Estate,<br/>
                    Thirumudivakkam, Chennai – 600 132
                  </a>
                  <p className="footer__address-label" style={{marginTop:'0.6rem'}}>Unit II</p>
                  <a
                    href="https://www.google.com/maps/place/MILLTECH+CNC+---UNIT+2/@12.9645931,80.0856174,17z/data=!3m1!4b1!4m6!3m5!1s0x3a52f5400a72f09d:0x645c791a6668f1a4!8m2!3d12.9645931!4d80.0856174!16s%2Fg%2F11flhf5kmd?entry=ttu&g_ep=EgoyMDI2MDYyMS4wIKXMDSoASAFQAw%3D%3D"
                    target="_blank" rel="noopener noreferrer"
                    className="footer__address"
                  >
                    Plot No. 28, Arul Murugan Nagar,<br/>
                    MKB Industrial Estate, Thirumudivakkam
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p className="footer__copy">© {year} MILLTECH CNC. All rights reserved.</p>
          <p className="footer__motto">We value <strong>TIME</strong> × <strong>QUALITY</strong> + <strong>METHOD</strong></p>
          <p className="footer__made">
            Made with ♥ by{' '}
            <a
              href="https://infinty-web-tech-ochre.vercel.app/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <strong>Infinity Web Tech</strong>
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;